"use client";

import {
  BarChart3,
  CalendarClock,
  LayoutGrid,
  MessagesSquare,
  Megaphone,
  Settings,
  Users,
  UtensilsCrossed,
  Star,
} from "lucide-react";
import { cn } from "@/lib/cn";
import { NAV_ITEMS } from "@/lib/mock-data";

const ICON: Record<string, typeof UtensilsCrossed> = {
  today: UtensilsCrossed,
  reservations: CalendarClock,
  floor: LayoutGrid,
  guests: Users,
  inbox: MessagesSquare,
  marketing: Megaphone,
  community: Star,
  analytics: BarChart3,
  settings: Settings,
};

const SECTIONS = ["Operate", "Grow", "System"] as const;

export interface PrimaryNavProps {
  activeId: string;
  onSelect: (id: string) => void;
  className?: string;
}

/** Global Shell primitive: primary navigation. */
export function PrimaryNav({ activeId, onSelect, className }: PrimaryNavProps) {
  return (
    <nav aria-label="Primary" className={className}>
      {SECTIONS.map((section) => (
        <div key={section} className="mb-1">
          <p className="px-3 pb-1.5 pt-4 text-[10px] font-bold uppercase tracking-wider text-text-secondary first:pt-0">
            {section}
          </p>
          <ul className="space-y-0.5">
            {NAV_ITEMS.filter((item) => item.section === section).map((item) => {
              const Icon = ICON[item.id];
              const active = item.id === activeId;
              return (
                <li key={item.id}>
                  <button
                    type="button"
                    onClick={() => onSelect(item.id)}
                    aria-current={active ? "page" : undefined}
                    className={cn(
                      "flex w-full items-center gap-2.5 rounded-control px-3 py-2.5 text-sm text-text-secondary hover:bg-surface-secondary",
                      active && "bg-status-success-bg font-bold text-brand-primary hover:bg-status-success-bg",
                    )}
                  >
                    <Icon aria-hidden="true" size={17} strokeWidth={1.8} />
                    {item.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}
